var React = require("react");

// Style objects
const carouselContainerStyle = {
  position: "relative",
  maxWidth: "1000px",
  margin: "0 auto",
};

const reviewCardStyle = (isFading) => ({
  backgroundColor: "#f3f4f6",
  padding: "24px",
  borderRadius: "8px",
  boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
  transition: "opacity 0.3s ease, transform 0.3s ease",
  opacity: isFading ? 0 : 1,
  transform: isFading ? "translateX(-20px)" : "none",
});

const starsStyle = {
  color: "#fbbf24",
  fontSize: "24px",
  marginBottom: "12px",
};

const reviewTextStyle = {
  marginBottom: "16px",
};

const authorInfoStyle = {
  display: "flex",
  alignItems: "center",
};

const authorInitialStyle = {
  backgroundColor: "#065f46",
  color: "white",
  width: "40px",
  height: "40px",
  borderRadius: "50%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontWeight: "bold",
  marginRight: "12px",
};

const authorNameStyle = {
  fontWeight: 600,
};

const reviewDateStyle = {
  color: "#6b7280",
  fontSize: "14px",
};

const googleLogoStyle = {
  height: "24px",
  marginTop: "16px",
};

const navButtonStyle = {
  position: "absolute",
  top: "50%",
  transform: "translateY(-50%)",
  backgroundColor: "white",
  border: "none",
  borderRadius: "50%",
  width: "40px",
  height: "40px",
  fontSize: "24px",
  cursor: "pointer",
  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
};

const prevButtonStyle = {
  ...navButtonStyle,
  left: "-20px",
};

const nextButtonStyle = {
  ...navButtonStyle,
  right: "-20px",
};

var ReviewCard = function (props) {
  var review = props.review;
  var isFading = props.isFading;
  return React.createElement(
    "div",
    {
      style: reviewCardStyle(isFading),
      className: 'review-card'
    },

    React.createElement(
      "div",
      { style: starsStyle },
      "★".repeat(review.rating),
      "☆".repeat(5 - review.rating)
    ),
    React.createElement("p", { style: reviewTextStyle }, review.text),
    React.createElement(
      "div",
      { style: authorInfoStyle },
      React.createElement(
        "div",
        { style: authorInitialStyle },
        review.author[0].toUpperCase()
      ),
      React.createElement(
        "div",
        null,
        React.createElement("p", { style: authorNameStyle }, review.author),
        React.createElement("p", { style: reviewDateStyle }, review.date)
      )
    ),
    React.createElement("img", {
      src: "https://www.google.com/images/branding/googlelogo/2x/googlelogo_color_92x30dp.png",
      alt: "Google",
      style: googleLogoStyle,
    })
  );
};

var GoogleReviewsCarousel = function (props) {
  var reviews = props.reviews;
  var _React$useState = React.useState(0),
    currentIndex = _React$useState[0],
    setCurrentIndex = _React$useState[1];
  var _React$useState2 = React.useState(false),
    isFading = _React$useState2[0],
    setIsFading = _React$useState2[1];

  var nextReview = function () {
    setIsFading(true);
    setTimeout(function () {
      setCurrentIndex(function (prevIndex) {
        return (prevIndex + 1) % reviews.length;
      });
      setIsFading(false);
    }, 300);
  };

  var prevReview = function () {
    setIsFading(true);
    setTimeout(function () {
      setCurrentIndex(function (prevIndex) {
        return (prevIndex - 1 + reviews.length) % reviews.length;
      });
      setIsFading(false);
    }, 300);
  };

  React.useEffect(function () {
    var intervalId = setInterval(nextReview, 5000);
    return function () {
      return clearInterval(intervalId);
    };
  }, []);

  return React.createElement(
    "div",
    { style: carouselContainerStyle },
    React.createElement(ReviewCard, {
      review: reviews[currentIndex],
      isFading: isFading,
    }),
    React.createElement(
      "button",
      { onClick: prevReview, style: prevButtonStyle },
      "‹"
    ),
    React.createElement(
      "button",
      { onClick: nextReview, style: nextButtonStyle },
      "›"
    )
  );
};

var sampleReviews = [
  {
    rating: 5,
    author: "Jenny Tan",
    text: "I tried bioelectric therapy at 2J Bioelectric Beauty, and Im impressed! The treatment itself was soothing, and I felt like my body was rejuvenated afterward. The only reason Im giving four stars instead of five is that I wish the session was a bit longer. Nevertheless, I noticed a decrease in my joint pain and an increase in my energy levels. I will definitely be returning!",
    date: "Just Now",
  },
  {
    rating: 5,
    text: "I have sensitive eyes all these while therefore lash usually last too long for me due to itch. Coincidentally, I found Arden, They are very affordable with impeccable workmanship and service. I respect that they are honest and passionate about their products. Not only that, they truly care about your own lashes and urge me not to rub my eye. 😊 So sweet!! Despite my eye rubbing habit, they are still being very patience on topping up my lashes. Such service is hard to find these days and I respect that! Most importantly their lashes look very natural and beautiful on me! Thank you so much and will definitely recommend Arden to my friends!",
    author: "Johanatan Khoo Li",
    date: "6 Hours ago",
  },
  {
    rating: 5,
    text: "I feel very blessed to know 2J Bioelectric Beauty by 2J true beauty, as my inflammation and body aches has been resolved",
    author: "Miss Elizabeth",
    date: "yesterday",
  },
  {
    rating: 5,
    text: "Have went to try their bioelectric therapy,  it was a smooth feeling, never feel eye irritation or tearing , the whole process make you feel relax plus the high bed feel comfy when lying down .",
    author: "Angelina Leck",
    date: "3 days ago",
  },
  {
    rating: 5,
    text: "Very glad I found 2J True Beauty. She is very skillful and meticulous. I always fall asleep during the process because she is so gentle.!",
    author: "lee wei ting",
    date: "5 days ago",
  },
  {
    rating: 5,
    text: "I had heard great things about bioelectric therapy, but experiencing it at 2J Bioelectric Beauty exceeded my expectations! The therapist took the time to understand my concerns and customized the treatment just for me. I felt safe and cared for throughout the session. Im amazed at how quickly my recovery has improved, and I cant recommend this enough!",
    author: "Carolina Tan",
    date: "2 weeks ago",
  },
  {
    rating: 5,
    text: "Bioelectric therapy at 2J Bioelectric Beauty has changed my life! Ive struggled with chronic pain for years, and after just one session, I experienced a significant reduction in discomfort. The staff is incredibly professional, and the facility is clean and calming. I appreciate how they focus on both physical and energetic healing. I will definitely be back for more sessions!",
    author: "Ahmad Fadil",
    date: "8 months ago",
  },
  {
    rating: 5,
    text: "Clean & peaceful environment. They are highly skilled n have an eye for details",
    author: "Roxxane Oh",
    date: "7 months ago",
  },
];

var GoogleReviews = function () {
  return React.createElement(
    "div",
    null,
    React.createElement(
      "h1",
      { style: { textAlign: "center" } },
      "What our clients say!"
    ),
    React.createElement(GoogleReviewsCarousel, { reviews: sampleReviews }),
    React.createElement(
      "p",
      { style: { textAlign: "center", marginBottom: "10%" } },
      "Powered by Web Wizards Widgets"
    )
  );
};

module.exports = GoogleReviews;
